import { Box, Pagination ,List,ListItem, Divider, ListItemAvatar, ListItemText,Avatar} from '@mui/material';
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { getNotificationsData } from '../../redux/reduser/notifications.js';
import usePagination from '../../utils/pagination';
import globalStyles from "../../style/global.js";
import PageTitle from '../../components/pageTitle/PageTitle.jsx';
import NotificationsIcon from '@mui/icons-material/Notifications';
import useStyles from "./notificationStyle";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";
import moment from 'moment';
import { Typography } from '@mui/material';
function Notifications() {
    const globalClasses = globalStyles();
    const classes = useStyles();
    const { t } = useTranslation();
    let [page, setPage] = useState(1);
  const PER_PAGE = 5;
  const { data, loading, error } = useSelector((state) => state.notifications);
  const count = Math.ceil(data.length / PER_PAGE);
  const _DATA = usePagination(data, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const dispatch = useDispatch();
 

  useEffect(() => {
    dispatch(getNotificationsData());
  }, []);
  return (
    <Box  className={globalClasses.background}>
        <PageTitle title={t("notifications")} showDivider={true} />
        {loading === true ? (
        <div className={globalClasses.center}>
          {" "}
          <CircularProgressBar />{" "}
        </div>
      ) : error == null ? (
        <>
        <List p="10" pt="3" spacing={2}>
        {_DATA.currentData().map(element => {
          return (
            <ListItem className={classes.listItem}>
            <ListItemAvatar>
              <Avatar>
                <NotificationsIcon color="secondary"/>
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={element.text} secondary={ 
                <> 
                 <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body3"
                color="text.primary"
              >
               {moment(element.date, "DDMMYYYYHH","ar").fromNow()}
              </Typography>
                
                </>
                } 
                />
            
          </ListItem>
       
          );
        })}
      </List>

      <Pagination
        count={count}
        
        page={page}
       
        color="primary" 
        className={classes.pagination}
       
        onChange={handleChange}
      />
        </>
      ) : (
        <div className={globalClasses.center}>
          {" "}
          <ErrorMessage title={error} />{" "}
        </div>
      )}
      
    </Box>
  );
}

export default Notifications
